import { defineMessages } from "react-intl"

export default defineMessages({
  heading: {
    id: "app.pages.profile.Profile.heading",
  },
  creationHeading: {
    id: "app.pages.profile.Profile.creationHeading",
  },
  personalinformation: {
    id: "app.pages.profile.Profile.personalinformation",
  },
  playtests: {
    id: "app.pages.profile.Profile.playtests",
  },
  gaminghabits: {
    id: "app.pages.profile.Profile.gaminghabits",
  },
  gamesplayed: {
    id: "app.pages.profile.Profile.gamesplayed",
  },
  profileStatus: {
    id: "app.pages.profile.Profile.profileStatus",
  },
  deleteButton: {
    id: "app.pages.profile.Profile.delete.button",
  },
  deleteConfirmationText: {
    id: "app.pages.profile.Profile.delete.confirmation.text",
  },

  redirectToHome: {
    id: "app.pages.profile.Profile.delete.redirectToHome",
  },
  deleteConfirmationSubText: {
    id: "app.pages.profile.Profile.delete.confirmation.subtext",
  },
  fieldRequired: {
    id: "app.site.required"
  }
})
